import {
  FETCH_GET_PROJECT_TEMPLATE_TASK_BY_ID_REQUEST,
  FETCH_GET_PROJECT_TEMPLATE_TASK_BY_ID_SUCCESS,
  FETCH_GET_PROJECT_TEMPLATE_TASK_BY_ID_FALUIRE,
} from './getProjectTemplateTaskByIDTypes'

const initialState = {
  loading: false,
  particularProjectTemplateTaskInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_GET_PROJECT_TEMPLATE_TASK_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_GET_PROJECT_TEMPLATE_TASK_BY_ID_SUCCESS : return {
      ...state,
      particularProjectTemplateTaskInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_GET_PROJECT_TEMPLATE_TASK_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      particularProjectTemplateTaskInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
